import { Component } from '@angular/core';

@Component({
    selector: 'page-notFound',
    templateUrl: './page-notFound.component.html',
    styleUrls: ['./page-notFound.component.scss'],
    standalone: false
})
export class PageNotFoundComponent {}
